<template>
    <div
        class="border-dashed border-t border-b ct-border-1 ct-bg-2--alt p-4 sm:p-6 space-y-4 sm:space-y-0 sm:space-x-4 flex flex-col sm:flex-row items-start"
    >
        <div class="flex space-x-3 sm:space-x-4">
            <img
                class="flex-shrink-0 h-10 w-10 rounded-full object-cover"
                :src="thumbnail"
                alt=""
            />
            <div class="text-left flex-grow">
                <p class="text-sm font-medium ct-fg-1">{{ $t("shared.help.onboarding_title") }}</p>
                <p class="mt-2 text-sm ct-fg-2">
                    {{ $t("shared.help.onboarding_subtitle") }}
                </p>
            </div>
        </div>
        <div
            class="flex-shrink-0 flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3 w-full sm:w-auto"
        >
            <ButtonTertiaryMd class="order-0 sm:order-1" @click="$emit('hide')">
                {{ $t("shared.skip") }}
            </ButtonTertiaryMd>
            <ButtonSecondaryMd class="order-1 sm:order-0" @click="showGallery">
                <PlayIcon />
                <span>{{ $t("shared.watch") }}</span>
            </ButtonSecondaryMd>
        </div>
        <CardGalleryPreview v-if="galleryOpened" :media="images" @close="hideGallery" />
    </div>
</template>

<script>
import { ButtonTertiaryMd, ButtonSecondaryMd } from "@easy/ui/buttons";
import { PlayIcon } from "@easy/ui/icons";
import { CardGalleryPreview } from "@easy/ui/cards";
import gregAvatar from "@/shared/assets/greg.png";

export default {
    components: {
        ButtonTertiaryMd,
        ButtonSecondaryMd,
        PlayIcon,
        CardGalleryPreview,
    },
    props: {
        modelValue: Boolean,
    },
    emits: ["update:modelValue", "hide"],
    data() {
        return {
            thumbnail: gregAvatar,
            videoSrc: "https://youtu.be/z_ZW1IriGYE",
        };
    },
    computed: {
        galleryOpened: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
        images() {
            return [
                {
                    src: this.videoSrc,
                    thumbnail: this.thumbnail,
                    type: "video",
                },
            ];
        },
    },
    methods: {
        showGallery() {
            this.galleryOpened = true;
        },
        hideGallery() {
            this.galleryOpened = false;
        },
    },
};
</script>
